import styles from './style.module.scss';
import { Link } from 'react-router-dom';
import { useNotify } from '@conductor/context/NotifyContext';

const IconNotify = ({ callback, to, isActive }) => {
	const { countNotify } = useNotify();

	return (
		<li
			key={`iconNotify-${to || '#'}`}
			onClick={() => { if (callback) callback(); }}
			className={`${styles.item} ${styles.notify} ${isActive ? styles.itemActive : ''}`}
		>
			<Link to={to ? to : '#'} className={styles.link}>
				<i className={`bi bi-bell ${styles.icon}`} />
				{(!!countNotify) &&
					<span className={styles.count}>{countNotify}</span>}
			</Link>
		</li>
	);
};

export default IconNotify;
